import { InKindGoalIcon, MonetaryGoalIcon } from '@/assets/images';
import CampaignGoalType from '@/constants/campaigns/CampaignGoalType';
import CampaignStatus from '@/constants/CampaignStatus';
import SortOrder from '@/constants/SortOrder';
import { CAMPAIGN_MAIN_TYPE } from '@/lib/constants/common';
import translate from '@/lib/intl/translate';

const CAMPAIGN_GOALS = [
  {
    value: CampaignGoalType.MONETARY,
    icon: MonetaryGoalIcon,
    text: translate('CAMPAIGN_MONETARY_LABEL'),
  },
  {
    value: CampaignGoalType.IN_KIND,
    icon: InKindGoalIcon,
    text: translate('CAMPAIGN_IN_KIND_LABEL'),
  },
];

const INIT_CAMPAIGN_PROPS = {
  assignees: [],
  campaignType: CAMPAIGN_MAIN_TYPE,
  description: '',
  displayName: '',
  goalAmount: 0,
  goalType: CAMPAIGN_GOALS[0].value,
  itemValue: 0,
  name: '',
  stretchAmount: 0,
  ticketPrice: 0,
  url: '',
};

const SUMMARY_METRICS_DEFAULT_PROPS = {
  avgDonation: 0,
  avgDonationPerDonor: 0,
  earnedRevenue: 0,
  maxDonation: 0,
  numDonations: 0,
  numDonorConstituents: 0,
  numNewDonors: 0,
  numReturningDonors: 0,
  totalAmount: 0,
};

const DEFAULT_CAMPAIGN_PROPS = {
  ...INIT_CAMPAIGN_PROPS,
  campaignId: '',
  date: '',
  endDate: null,
  expectedProgress: 0,
  isPinned: false,
  itemQuantity: 0,
  itemType: '',
  location: '',
  primaryAssigneeId: '',
  startDate: '',
  status: CampaignStatus.ACTIVE,
  ticketsSold: 0,
  updated: '',
  ...SUMMARY_METRICS_DEFAULT_PROPS,
};

const CampaignCardDefaultProps = {
  ...DEFAULT_CAMPAIGN_PROPS,
  isLoading: false,
};

const CAMPAIGN_DEFAULT_REQ_FIELDS = ['name', 'goalAmount'];

const CAMPAIGN_EVENT_REQ_FIELDS = [
  'location',
  'ticketPrice',
  'ticketsAvailable',
];

const CAMPAIGN_IN_KIND_REQ_FIELDS = ['itemType', 'itemQuantity', 'itemValue'];

const DONATIONS_TABLE_DEFAULT_SORTING = {
  orderBy: 'created',
  order: SortOrder.DESC,
};

export {
  CAMPAIGN_DEFAULT_REQ_FIELDS,
  CAMPAIGN_EVENT_REQ_FIELDS,
  CAMPAIGN_GOALS,
  CAMPAIGN_IN_KIND_REQ_FIELDS,
  CampaignCardDefaultProps,
  DEFAULT_CAMPAIGN_PROPS,
  DONATIONS_TABLE_DEFAULT_SORTING,
  INIT_CAMPAIGN_PROPS,
  SUMMARY_METRICS_DEFAULT_PROPS,
};
